<template>
    <Table
      :columns="cols"
      :data="tableData"
      :loading="loading"
      border
      :width="cols.reduce((a,v)=>a+v.width,0)+5"
      >
      <BaseLoading v-if="loading" />
      <div class="flex-wrap flex-right" style="font-size:12px;color:var(--subtext3)">

                  </div>
    </Table>
  </template>

<script>
import tableRender from '../../base/tableRender';
export default {
  name: 'CmTableYearHrp',
  data() {
    return {
      tableData: [{
        dep: '公司',
      }, {
        dep: '建设管理事业部',
      }, {
        dep: '房建监理事业部',
      }, {
        dep: '市政监理事业部',
      }],
      loading: true,
    };
  },
  computed: {
    cols() {
      return [{
        key: 'dep',
        title: '部门',
        align: 'center',
        width: 200,
      }, {
        key: 'predict_hrp',
        title: '预测人均产值(万元)',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.predict_hrp),
      }, {
        key: 'current_hrp',
        title: '现阶段人均产值(万元)',
        align: 'center',
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.current_hrp),
        width: 200,
      }, {
        key: 'predict_hrb',
        title: '预测人均收费(万元)',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.predict_hrb),
      }, {
        key: 'current_hrp',
        title: '人力统计人均产值(万元)',
        align: 'center',
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.raw_hrp),
        width: 200,
      }, {
        key: 'predict_hrb',
        title: '人力统计人均收费(万元)',
        align: 'center',
        width: 200,
        render: (h, params)=>tableRender.renderAmountNoFormat(h, params.row.raw_hrb),
      }];
    },
  },
  props: {
    year: {
      type: String | Number,
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const url = `cm/tables/hrp?year=${this.year}`;
      this.$api.get(url).then((res)=>{
        const result = res.data.data;
        this.tableData = result.data;
        this.created_at = result.created_at;
      }).finally(()=>{
        this.loading = false;
      });
    },
    exportExcel() {

    },
  },
};
</script>

  <style>

  </style>
